import Vue from 'vue'
import Vuex from 'vuex'
import { setCookie } from '@/lib/cookie'
Vue.use(Vuex)

var userLanguage = navigator.language || navigator.userLanguage;
let defaultLanguage = "en"
console.log(userLanguage);
if(userLanguage.indexOf("zh") != -1){
  defaultLanguage = "tc"
}else if(userLanguage.indexOf("en") != -1){
  defaultLanguage = "en"
}else if(userLanguage.indexOf("ja") != -1){
  defaultLanguage = "ja"
}else if(userLanguage.indexOf("ko") != -1){
  defaultLanguage = "ko"
}
let curLan = localStorage.getItem("r3-twitch-lan") || defaultLanguage;

const store = new Vuex.Store({
	state: {
		userInfo: JSON.parse(localStorage.getItem('ninja3_twitchdrop_userinfo'))  || '',
		twitchAccountMsg:JSON.parse(localStorage.getItem('ninja3_twitch_account_msg'))  || '',
		session: localStorage.getItem('ninja3_twitchdrop_session') || '',
		curLan,
		userPlayMusic:"",//用户是否开启音乐
		pop: {
			login: false,
			rule: false, // 规则弹窗
			success:false, //绑定成功弹窗
			share: false, // 分享弹窗
		}
	},
	mutations: {
		clearUserState() {
			localStorage.setItem('ninja3_twitchdrop_session', '')
			setCookie('ninja3-official-session', '', 7)
			window.location.reload()
		},
        updateState(state, { name, value }) {
			if (name == 'session') {
				localStorage.setItem('ninja3_twitchdrop_session', value)
				setCookie('ninja3-official-session', value, 7)
			}
			if (name == 'twitchAccountMsg') {
				localStorage.setItem('ninja3_twitch_account_msg', JSON.stringify(value))
			}

			if (name == 'userInfo') {
				console.log(value)
				localStorage.setItem('ninja3_twitchdrop_userinfo', JSON.stringify(value))
			}

			if (name == 'curLan') {
				localStorage.setItem('r3-twitch-lan', value)
			}

			if (name == 'token') {
				localStorage.setItem('ninja3_ali_token', value)
			}

			console.log(name, value)

			state[name] = value
		},
		// 关闭弹窗
		popClose(state, name) {
			state.pop[name] = false

			let flag = false
			for (let i in state.pop) {
				if (state.pop[i]) {
					flag = true
				}
			}

			if (!flag) {
				document.querySelector('html').classList.remove('popShow')
			}
		},
		// 打开弹窗
		popOpen(state, name) {
			state.pop[name] = true

			for (let i in state.pop) {
				if (state.pop[i]) {
					document.querySelector('html').classList.add('popShow')
				}
			}
		}
	},
	actions: {},
	modules: {}
})

export default store
